import React from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.ReactNode;
};

const CONTENT_ID = '#newron-content';

function ClientContent({ children }: Props): React.ReactPortal | null {
  const [isInDocument, setIsInDocument] = React.useState<boolean>(false);
  const timer = React.useRef<ReturnType<typeof setTimeout>>(null);

  React.useEffect(() => {
    const checkInDocument = () => {
      const el = document.querySelector(CONTENT_ID);
      if (!el) {
        if (timer.current) {
          clearTimeout(timer.current);
        }
        timer.current = setTimeout(checkInDocument, 50);
        setIsInDocument(false);
        return;
      } else {
        setIsInDocument(true);
      }
    };
    checkInDocument();
  }, []);

  if (!isInDocument) {
    return null;
  }

  const el = document.querySelector(CONTENT_ID);

  if (!el) {
    console.warn('Could not find newron content element in the document');
    return null;
  }

  return ReactDOM.createPortal(children, el);
}

export { ClientContent };
